module.exports = __webpack_public_path__ + "img/present.636a64c.png";